import { isSameOriginUrl } from '@Core/lib/tasks/utils/navigate';
import axios, { type InternalAxiosRequestConfig } from 'axios';

// Session cookies are host-only and `config/cors.php` never allows credentials, so the
// browser blocks every credentialed request to another origin. Send those without cookies.
export function omitCrossOriginCredentials(
  config: InternalAxiosRequestConfig
): InternalAxiosRequestConfig {
  if (!isSameOriginUrl(axios.getUri(config))) {
    config.withCredentials = false;
  }

  return config;
}
